import React from "react";
import QuizApp from "./QuizApp"; // 匯入 QuizApp

function App() {
  return (
    <div>
      <QuizApp />
    </div>
  );
}

export default App;
